import React from "react";
import styles from "./CenterBoxBottom.scss";

export const CenterBoxBottom = ({ children }) => {
    return <div className={styles.base}>{children}</div>;
};
